import z from 'zod'
import { nullSafeOptionalFirestoreTimestamp } from '../shared/schema'

export const schema = z.object({
  slideDeckId: z.string(),
  slideDeckTypeId: z.string(),
  // this should be updatedAt, but we have a typo in rules
  updatedAt: nullSafeOptionalFirestoreTimestamp(),
  userId: z.string(),
})

export const empty = Object.freeze(
  schema.parse({
    catalogId: '',
    slideDeckId: '',
    slideDeckVersion: '',
    slideDeckTypeId: '',
    userId: '',
  })
)

export interface FirestoreUserProfileFavoriteSlideDeck extends z.infer<
  typeof schema
> {}
